if (!customElements.get('product-name-field')) {
  class ProductNameField extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name="properties[Name]"]');
      this.errorElement = this.querySelector('.product-name-field__error');
      this.required = this.dataset.required === 'true';
      this.maxLength = parseInt(this.dataset.maxLength, 10) || 0;
      this.requiredMessage = this.dataset.requiredMessage || 'Please enter your name.';
      this.maxLengthMessage = this.dataset.maxLengthMessage || 'Name is too long.';

      if (!this.input) return;

      this.input.addEventListener('input', () => this.clearError());
      this.bindFormValidation();
    }

    bindFormValidation() {
      const formId = this.input.getAttribute('form');
      const form = formId ? document.getElementById(formId) : this.input.closest('form');

      if (!form || form.dataset.nameFieldBound === 'true') return;

      form.dataset.nameFieldBound = 'true';
      form.addEventListener(
        'submit',
        (event) => {
          const nameFields = form
            .closest('product-info')
            ?.querySelectorAll('[data-product-name-field]');

          if (!nameFields?.length) return;

          for (const nameField of nameFields) {
            if (!nameField.validate?.()) {
              event.preventDefault();
              event.stopImmediatePropagation();
              nameField.input?.focus();
              return;
            }
          }
        },
        true
      );
    }

    validate() {
      const value = this.input.value.trim();

      if (this.required && value === '') {
        this.showError(this.requiredMessage);
        return false;
      }

      if (this.maxLength > 0 && value.length > this.maxLength) {
        this.showError(this.maxLengthMessage);
        return false;
      }

      if (!this.required && value === '') {
        this.input.disabled = true;
      }

      this.clearError();
      return true;
    }

    showError(message) {
      if (this.errorElement) {
        this.errorElement.textContent = message;
        this.errorElement.hidden = false;
      }

      this.input.setAttribute('aria-invalid', 'true');
    }

    clearError() {
      if (this.errorElement) {
        this.errorElement.textContent = '';
        this.errorElement.hidden = true;
      }

      this.input.removeAttribute('aria-invalid');
      this.input.disabled = false;
    }
  }

  customElements.define('product-name-field', ProductNameField);
}
